import styled from 'styled-components';

const Title = styled.div`
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: ${(props) => props.theme.appLayout.notificationsFontColor};
  margin-bottom: 5px;
`;

const Text = styled.div`
  font-size: 13px;
  line-height: 15px;
  color: ${(props) => props.theme.appLayout.notificationsFontColor};
  margin-bottom: 5px;
`;

const NotificationStyled = styled.div`
  display: flex;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.neutral900};
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Image = styled.div`
  width: 52px;
  height: 52px;
  margin-right: 12px;
  flex: none;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
`;

const Tag = styled.div`
  height: 15px;
  padding: 0 7px;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: #ffffff;
  text-transform: uppercase;
  margin-bottom: 5px;
  background: ${(props) => (props.color ? props.color : '')};
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  width: auto;
`;

const TimeDate = styled.div`
  font-size: 13px;
  line-height: 15px;
  color: ${(props) => props.theme.appLayout.notificationsFontColor};
  text-align: right;
  display: flex;
  align-items: center;
`;

const TabSelectButton = styled.div<{ selected: boolean }>`
  div {
    background: ${(props) => (props.selected ? '#403C3B;' : '#161313')};
    border-radius: 100px;
    padding: 0 12px;
    height: 35px;
    display: flex;
    align-items: center;
  }
  background: ${(props) =>
    props.selected
      ? 'linear-gradient(160.43deg,#f58e35 1.87%,#f26c6b 50.93%,#ee288a 99.33%);'
      : '#161313'};
  padding: 1px;

  color: ${(props) => (props.selected ? '#FEFEFE' : '#C6BDBD')};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  border-radius: 100px;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  @media (max-width: 800px) {
    margin-right: 8px;
  }
`;
const Tabs = styled.div`
  /* background: linear-gradient(
    270deg,
    #1c1716 3.82%,
    rgba(28, 23, 22, 0) 26.36%
  ); */
  overflow-y: auto;
  display: flex;
  align-items: center;
  ::-webkit-scrollbar {
    display: none;
  }
`;
export {
  Title,
  Tag,
  Image,
  NotificationStyled,
  Text,
  TimeDate,
  TabSelectButton,
  Tabs
};
